var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZalo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdii_1613_15480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.19995,
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.530029
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4786 15.3114V14.8728H20.7916V21.0348H20.041C19.8925 21.0351 19.7499 20.9764 19.6445 20.8718C19.539 20.7671 19.4794 20.6249 19.4786 20.4763V20.4773C18.9306 20.8785 18.2689 21.0943 17.5897 21.0933C16.7411 21.0933 15.9272 20.7563 15.327 20.1565C14.7268 19.5566 14.3893 18.7429 14.3888 17.8944C14.3893 17.0458 14.7268 16.2321 15.327 15.6322C15.9272 15.0324 16.7411 14.6954 17.5897 14.6954C18.2685 14.6946 18.9299 14.9104 19.4777 15.3114H19.4786ZM14.0486 12.8922V13.092C14.0486 13.4644 13.9989 13.7685 13.7562 14.1252L13.727 14.1583C13.6461 14.249 13.5675 14.3416 13.4911 14.4361L9.27747 19.7248H14.0486V20.4734C14.0486 20.5472 14.0341 20.6203 14.0058 20.6885C13.9775 20.7567 13.9361 20.8186 13.8838 20.8707C13.8316 20.9229 13.7696 20.9642 13.7014 20.9924C13.6331 21.0205 13.56 21.035 13.4862 21.0348H7.30469V20.682C7.30469 20.2502 7.4119 20.0572 7.54836 19.8564L12.0388 14.2958H7.49183V12.8922H14.0496H14.0486ZM22.3832 21.0348C22.2591 21.0348 22.1401 20.9855 22.0524 20.8978C21.9647 20.8101 21.9154 20.6911 21.9154 20.567V12.8922H23.3199V21.0348H22.3832ZM27.4741 14.6564C27.8972 14.6563 28.3163 14.7395 28.7073 14.9013C29.0983 15.0631 29.4536 15.3004 29.7529 15.5995C30.0522 15.8987 30.2897 16.2538 30.4517 16.6447C30.6138 17.0356 30.6973 17.4546 30.6974 17.8778C30.6975 18.3009 30.6143 18.72 30.4525 19.111C30.2907 19.502 30.0534 19.8573 29.7543 20.1566C29.4551 20.4559 29.1 20.6934 28.7091 20.8554C28.3182 21.0175 27.8992 21.101 27.476 21.1011C26.6214 21.1014 25.8017 20.7621 25.1972 20.158C24.5927 19.5539 24.253 18.7344 24.2527 17.8797C24.2524 17.0251 24.5917 16.2054 25.1958 15.6009C25.7999 14.9964 26.6194 14.6567 27.4741 14.6564ZM17.5907 19.7765C17.8415 19.7822 18.0909 19.7377 18.3243 19.6457C18.5577 19.5536 18.7704 19.4159 18.9498 19.2405C19.1292 19.0651 19.2718 18.8556 19.3691 18.6244C19.4665 18.3931 19.5166 18.1448 19.5166 17.8939C19.5166 17.643 19.4665 17.3946 19.3691 17.1633C19.2718 16.9321 19.1292 16.7226 18.9498 16.5472C18.7704 16.3719 18.5577 16.2341 18.3243 16.1421C18.0909 16.05 17.8415 16.0055 17.5907 16.0112C17.0988 16.0224 16.6308 16.2257 16.2869 16.5775C15.9429 16.9294 15.7504 17.4019 15.7504 17.8939C15.7504 18.3859 15.9429 18.8584 16.2869 19.2102C16.6308 19.562 17.0988 19.7653 17.5907 19.7765ZM27.4741 19.7736C27.9769 19.7736 28.4591 19.5738 28.8146 19.2183C29.1701 18.8628 29.3699 18.3806 29.3699 17.8778C29.3699 17.375 29.1701 16.8928 28.8146 16.5373C28.4591 16.1817 27.9769 15.982 27.4741 15.982C26.9713 15.982 26.4891 16.1817 26.1335 16.5373C25.778 16.8928 25.5783 17.375 25.5783 17.8778C25.5783 18.3806 25.778 18.8628 26.1335 19.2183C26.4891 19.5738 26.9713 19.7736 27.4741 19.7736Z",
    fill: "#0075FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdii_1613_15480",
    x: -6.87313,
    y: -8.67318,
    width: 51.7463,
    height: 51.7463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5.43656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1613_15480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1613_15480",
    result: "effect2_dropShadow_1613_15480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1613_15480",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1613_15480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1613_15480",
    result: "effect4_innerShadow_1613_15480"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZalo);
export default __webpack_public_path__ + "static/media/zalo.95554f467e0525086e393267881a285d.svg";
export { ForwardRef as ReactComponent };